import tripshaLogo from '@/assets/img/tripsha-logo-nobeta.png'
import styled from 'styled-components'
import { MenuOutlined } from '@ant-design/icons'
import { useApp } from '@/hooks'
import { Link } from 'react-router-dom'
import { UserMenu } from '@/layouts/UserMenu'
import { useSelector } from 'react-redux'
import { Layout } from 'antd'
import { useLocation } from 'react-router-dom'
import { svgImage } from '@/assets/svg/svg-icon'

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
`
const Logo = styled.img`
  max-width: 110px;
  cursor: pointer;
  margin-left: -10px;
`

export const TripshaLogo = ({ user }) => {
  const path = user.isHostView
    ? '/dashboard/host-organizations'
    : '/dashboard/organizations'
  return (
    <div className="tripsha-logo">
      <Link to={{ pathname: path }}>
        <div className='header-logo'>
          <img src={tripshaLogo} alt="Tripsha" style={{ height: 22, width: 'auto', marginTop: 4 }} />
        </div>
      </Link>
    </div>
  )
}
export const DashboardHeader = () => {
  const { setVisible } = useApp()
  return (
    <HeaderContainer>
      <MenuOutlined
        style={{ fontSize: '16px' }}
        onClick={() => setVisible(true)}
      />
    </HeaderContainer>
  )
}
export const TransparentDashboardHeader = ({ className }) => {
  const { setVisible } = useApp()
  return (
    <HeaderContainer
      className={className}
      style={{ position: 'absolute', top: '15px', left: '15px' }}
    >
      <MenuOutlined
        onClick={() => setVisible(true)}
        style={{ fontSize: '25px' }}
      />
    </HeaderContainer>
  )
}

const hideOnRoutes = ['/login'];
export const MainHeader = () => {
  const { currentUser } = useSelector((state) => state.auth)
  const location = useLocation()
  if (hideOnRoutes.includes(location.pathname)) return null;
  return (
    <>
      <Layout.Header className="main-header">
        <div className="dashboard-title-row" style={{ display: 'flex', alignItems: 'center' }}>
          {currentUser?.isAdmin && <DashboardHeader />}
          <TripshaLogo user={currentUser} />
        </div>
        {currentUser?._id ? <UserMenu /> : <></>}
      </Layout.Header>
      <div style={{ height: 60, width: '100%' }} />
    </>
  )
}
